// fetchCountries.js
import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { get_all_states } from "../../endpoints/API";
// import { useSelector } from "react-redux";

export const fetchStates = async (setStates, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await get_all_states();
    if (response.statusText=="OK") {
      const data = response?.data;
      setStates(data);
    } else {
      message.error("Failed to fetch states.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching states.");
  }
};
